module.exports = __webpack_public_path__ + "static/media/elegant-4.9f711872.png";